const formatMinutesInHours = (minutes?: number | null | undefined, padStart?: number) : string => {	
	if(minutes){

		const hh = padStart ? Math.floor(minutes / 60).toString().padStart(padStart, "0") : Math.floor(minutes / 60).toString();
		let mm = (minutes % 60).toString();

		mm = mm.length === 1 ? `0${mm}` : mm;

		return `${hh}:${mm}`;
	}

	return padStart ? "0" : "00:00";
};

const formatHoursInMinutes = (hoursMinutes: string) : number => {
	if(hoursMinutes){
		const splitDuration = hoursMinutes.split(":");
		const hours = splitDuration[0];
		const minutes = splitDuration[1];
		return parseFloat(hours) * 60 + parseFloat(minutes);
	}

	return 0;
};
  
export {formatMinutesInHours, formatHoursInMinutes};
